import {
  AreaChartIcon,
  ChartColumn,
  ChartColumnIncreasing,
  ChartNetwork,
  ChartNoAxesCombined,
  HandCoins
} from 'lucide-react';
import {
  HomeIcon,
  AdjustmentsHorizontalIcon,
  BanknotesIcon,
  CheckBadgeIcon,
  ClipboardDocumentListIcon,
  ChartPieIcon,
} from '@heroicons/react/24/outline';
import { MenuItem } from '../types';
import { FeatureFlags } from './featureFlags';

export const menuItems: MenuItem[] = [
  {
    label: 'Home',
    path: '/',
    icon: <HomeIcon className="w-5 h-5" />,
    featureFlag: FeatureFlags.DASHBOARD_MODULE,
  },
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: <AreaChartIcon className="w-5 h-5" />,
    featureFlag: FeatureFlags.DASHBOARD_MODULE,
    children: [
      {
        label: 'Visor de portafolio',
        path: '/dashboard/graphics',
        description: "Consulta gráficas interactivas por portafolio.",
        icon: <ChartPieIcon className='w-4 h-4' />,
        featureFlag: FeatureFlags.DASHBOARD_GRAPHICS
      },
      {
        label: 'Flujos futuros',
        path: '/dashboard/future-flows',
        description: "Revisa los flujos proyectados por instrumento.",
        icon: <ChartNoAxesCombined className='w-4 h-4' />,
        featureFlag: FeatureFlags.DASHBOARD_FUTURE_FLOWS
      },
      {
        label: 'Medidas de sensibilidad',
        path: '/dashboard/sensitivity-measures',
        description: "Analiza duración, convexidad y DV01.",
        icon: <ChartNetwork className='w-4 h-4' />,
        featureFlag: FeatureFlags.DASHBOARD_SENSITIVITY_MEASURES
      },
    ]
  },
  {
    label: 'Ordenes',
    path: '/orders',
    icon: <BanknotesIcon className="w-5 h-5" />,
    featureFlag: FeatureFlags.ORDERS_MODULE,
    children: [
      {
        label: 'Renta fija',
        path: '/orders/fixed-income',
        description: "Opera y administra inversiones en instrumentos de deuda.",
        icon: <ChartColumnIncreasing className='w-4 h-4' />,
        featureFlag: FeatureFlags.ORDERS_FIXED_INCOME
      },
      {
        label: 'Renta variable',
        path: '/orders/variable-income',
        description: "Opera y administra inversiones en acciones.",
        icon: <ChartColumn className='w-4 h-4' />,
        featureFlag: FeatureFlags.ORDERS_VARIABLE_INCOME
      },
      {
        label: 'Instrumentos',
        path: '/orders/instruments',
        description: "Consulta, registra y administra los instrumentos financieros disponibles para negociación.",
        icon: <HandCoins className='w-4 h-4' />,
        featureFlag: FeatureFlags.ORDERS_INSTRUMENTS
      },
      {
        label: 'Ordenes de Clientes',
        path: '/orders/client-orders',
        description: "Gestiona las ordenes de clientes.",
        icon: <ClipboardDocumentListIcon className='w-4 h-4' />,
        featureFlag: FeatureFlags.ORDERS_MODULE
      },
    ]
  },
  {
    label: 'Control de límites',
    path: '/limit-control',
    icon: <ClipboardDocumentListIcon className="w-5 h-5" />,
    featureFlag: FeatureFlags.LIMIT_CONFIG_MODULE,
    children: [
      {
        label: 'Configuración',
        description: "Gestiona límites, parámetros y ajustes del sistema.",
        path: '/limit-control/limit-config',
        icon: <AdjustmentsHorizontalIcon className='w-4 h-4' />,
        featureFlag: FeatureFlags.LIMIT_CONFIG_MODULE
      },
      {
        label: 'Evaluación',
        path: '/limit-control/limit-evaluation',
        icon: <CheckBadgeIcon className='w-4 h-4' />,
        featureFlag: FeatureFlags.LIMIT_EVALUATION_MODULE
      },
    ]
  },

  // Aquí agregar nuevos items al menú



]; 